<template>
	<v-dialog :model-value="Boolean(dialogs.imageKey)" :fullscreen="fullscreen" max-width="960" class="nav-image-dialog" @update:model-value="(value) => !value && close()">
		<v-card rounded="xl" class="nav-image-dialog__card">
			<div class="nav-image-dialog__toolbar">
				<v-btn icon variant="text" size="small" :aria-label="t('Close')" @click="close">
					<v-icon>close</v-icon>
				</v-btn>
				<v-btn icon variant="text" size="small" :disabled="!url" @click="zoom(ZOOM_STEP)">
					<v-icon>add</v-icon>
				</v-btn>
				<v-btn icon variant="text" size="small" :disabled="!url || scale <= 1" @click="zoom(-ZOOM_STEP)">
					<v-icon>remove</v-icon>
				</v-btn>
				<v-btn icon variant="text" size="small" @click="fullscreen = !fullscreen">
					<v-icon>{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
				</v-btn>
			</div>
			<div class="nav-image-dialog__body">
				<v-progress-circular v-if="loading" indeterminate color="primary" />
				<img v-else-if="url" :src="url" alt="" class="nav-image-dialog__image" :style="{ transform: `scale(${scale})` }" />
			</div>
		</v-card>
	</v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useChromeDialogs } from '@/composables/useChromeDialogs';
import { loadCartLineImage } from '@/iframe/legacyNavActions';
import { useTranslator } from '@/composables/useTranslator';

const ZOOM_STEP = 0.5;

const t = useTranslator();
const dialogs = useChromeDialogs();

const url = ref(null);
const loading = ref(false);
const scale = ref(1);
const fullscreen = ref(false);

const release = () => {
	if (url.value?.startsWith('blob:')) URL.revokeObjectURL(url.value);
	url.value = null;
};

watch(
	() => dialogs.imageKey,
	async (key) => {
		release();
		scale.value = 1;
		if (!key) return;
		loading.value = true;
		const next = await loadCartLineImage(key);
		loading.value = false;
		if (dialogs.imageKey !== key) {
			if (next?.startsWith('blob:')) URL.revokeObjectURL(next);
			return;
		}
		url.value = next;
	}
);

const zoom = (step) => {
	scale.value = Math.min(4, Math.max(1, scale.value + step));
};

const close = () => {
	dialogs.imageKey = null;
	fullscreen.value = false;
};
</script>
